<template>
  <div class="contact-us">
    <a :href="`tel:${supplierPhone}`">Having trouble? Call {{ supplierName }} on <b>{{ supplierPhone }}</b></a>
    <small class="_margin-top-10">Monday to Friday 9am to 5pm</small>
    <small>Closed on Bank Holidays</small>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  data() {
    return {
      supplierPhone: process.env.VUE_APP_SUPPLIER_PHONE,
      supplierName: process.env.VUE_APP_SUPPLIER_NAME
    };
  }
};
</script>

<style lang="scss">
.contact-us {
  a {
    color: $font-paragraph-colour;
    padding: 10px 0;

    &:hover,
    &:focus {
      color: lighten($font-paragraph-colour, 10%);
      text-decoration: none;
    }
  }

  small {
    display: block;
    font-size: 65%;
  }
}
</style>
